module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./MyMessageView.js"));
	}, "MyMessageView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MyMessageView!./src/pages/MessageManage/MyMessage/MyMessageView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=MyMessageView!./src/pages/MessageManage/MyMessage/MyMessageView.js
// module chunks = 43